import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/dostavkee/_sidebar-layout/orders/$public_id/')({
    onEnter: (context) => {
        document.title = `Dostavkee - Заказ №${context.params.public_id}`
    },
})
